<template>
  <div class="edit-platform">
    <div class="breadcrumb" style="background: #fff">申请提现</div>
    <!-- <div class="third-title"><span>基础信息</span></div> -->
    <div class="order-detail-basic">
      <el-form :rules="rules" :model="submitForm" ref="rulesTixian" label-width="140px" class="demo-ruleForm">
        <el-form-item label="平台号:">
          <span>{{ storeListByCode.store.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ storeListByCode.store.name }} </el-form-item>
        <el-form-item label="结算余额:">
          <!-- {{ storeListByCode.balanceMap.VPAY_SETTLE.balance }} --> {{ storeListByCode.balances.SETTLE.balance }} </el-form-item>
        <el-form-item label="提现金额:" prop="withdrawal">
          <el-input v-model="submitForm.withdrawal"></el-input>
        </el-form-item>
        <el-form-item label="实际提现金额:">
          <el-input :disabled="true" v-model="submitForm.withdrawalReal"></el-input>
          <el-tooltip class="item" effect="dark" content="实际提现金额=提现金额x(1-6‰)" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="收款账户:"> {{ basicInfo.collectionAccount }} </el-form-item>
        <el-form-item label="户名:"> {{ basicInfo.accountName }} </el-form-item>
        <el-form-item label="开户行:"> {{ basicInfo.bank }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="save" :loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { applyWithdrawal } from '@/api/epay'
import { getByStoreId } from '@/api/crm'

export default {
  name: 'applyWithdrawal',
  data () {
    var validateWithdrawal = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (!value) {
        return callback(new Error('提现金额不能为空'))
      }
      setTimeout(() => {
        if (!regAmount.test(value)) {
          // callback(new Error('请输入正整数(不包括0)'))
          callback(new Error('请输入正数且小数点后精度两位'))
        } else if (value > 0) {
          // if (value > this.storeListByCode.balanceMap.VPAY_SETTLE.balance) {
          //   this.submitForm.withdrawal = '';
          //   this.submitForm.withdrawalReal = '';
          //   callback(new Error('提现金额不能大于结算金额！'));
          // } else {
          this.submitForm.withdrawalReal = Math.floor((this.submitForm.withdrawal * (1 - 0.006)) * 100) / 100
          console.log('this.submitForm.withdrawalReal', this.submitForm.withdrawalReal)
          // }
        } else {
          if (value < 0) {
            callback(new Error('提现金额必须大于0！'))
          } else {
            callback()
          }
        }
      }, 0)
    }
    return {
      loading: false,
      formInline: {
        storeId: ''
      },
      storeListByCode: {
        balanceMap: {
          VPAY_SETTLE: {}

        },
        store: {}
      },
      submitForm: {
        withdrawal: '',
        withdrawalReal: '',
        bank: '',
        collectionAccount: '',
        accountName: ''
      },
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      rules: {
        withdrawal: [
          { validator: validateWithdrawal, trigger: 'blur' }
        ]
      }

    }
  },
  mounted () {
    if (this.$route.query.store) sessionStorage.setItem('epayFlag', true)
  },
  created () {
    let id = JSON.parse(this.$route.query.store).store.id
    getByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        console.log(obj)
        obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.basicInfo = obj
        console.log(this.basicInfo)
      } else {

      }
    })

    if (this.$route.query.store) {
      this.storeListByCode = JSON.parse(this.$route.query.store)
      console.log(this.storeListByCode, 'this.storeListByCodec')
      this.formInline.storeId = JSON.parse(this.$route.query.store).store.id
    }
  },
  methods: {
    save () {
      let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(this.submitForm.withdrawal)) {
        this.$message.error('提现金额必须为正数')
        return
      }
      if (!Number(this.submitForm.withdrawal) > 0) {
        this.$message.error('提现金额必须大于0')
        return
      }
      if (this.submitForm.withdrawal > this.storeListByCode.balances.SETTLE.balance) {
        this.$message.error('提现金额不能大于结算金额')
        return
      }
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (!regAmount.test(this.submitForm.withdrawal)) {
        // this.$message.error('请输入正数且小数点后精度两位')
        return
      }
      console.log('1111', this.submitForm.withdrawalReal)
      let formVal = {
        totalAmount: this.submitForm.withdrawal * 1,
        // bankCardholder: this.basicInfo.accountName,
        // bankCardno: this.basicInfo.collectionAccount,
        // bankName: this.basicInfo.bank,
        amount: this.submitForm.withdrawalReal,
        storeId: this.formInline.storeId,
        accountType: 'ACCT',
        originType: 'WEB',
        tradeMethod: 'REFUND_CASHOUT',
        channel: 'B2B'
      }
      this.loading = true
      applyWithdrawal(formVal).then(res => {
        if (res.data.success) {
          this.$message.success('申请成功')
          this.$router.go(-1)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";
</style>
